// var api = "http://218.249.73.244:58080";
// var api = "http://218.249.73.246:58080";
// var api = "http://192.168.11.25:58080";
const defaultApi =
  process.env.NODE_ENV === "production"
    ? "https://irshare.cn"
    : "http://10.134.86.138:48080";
const api = process.env.VUE_APP_API_BASE_URL || defaultApi;
// var api = "https://irshare.cn";
//var api = "https://irshare.cn";


export default {
  api: `${api}`,
  lation: `${api}/web-api/web/gateway/regulationPage`, //制度分页
  lationWeb: `${api}/web-api/web/gateway/regulationPageWeb`, //首页政策分页
  news: `${api}/web-api/web/gateway/newsPage`, //新闻分页
  newsde: `${api}/web-api/web/gateway/getOneNews`, //新闻详情
  dianz: `${api}/web-api/web/gateway/praiseOneNews?id=`, //点赞新闻
  qxdianz: `${api}/web-api/web/gateway/praiseCancelOneNews?id=`, //点赞新闻
  yiqi: `${api}/web-api/web/gateway/singleInstrumentPage`, //仪器分页
  yiqixq: `${api}/web-api/web/gateway/getOneSingleInstrument`, //仪器详情
  fenlei: `${api}/web-api/web/gateway/getCategoryListOfHome`, //仪器分类
  xueke: `${api}/web-api/web/gateway/getSubjectListOfHome?subName=`, //仪器学科
  diqu: `${api}/web-api/web/gateway/getlocationCodeListOfHome`, //仪器地区
  xiangguan: `${api}/web-api/web/gateway/selectSingleListWebPage`, //相关仪器
  zhuce: `${api}/web-api/web/gateway/userCreate`, //注册
  denglu: `${api}/web-api/web/gateway/getUser?userId=`, //获取登录信息
  user: `${api}/web-api/web/gateway/updateUser`, //修改个人信息
  password: `${api}/web-api/web/gateway/updateUserPassword`, //修改密码
  collect: `${api}/web-api/web/gateway/collectOne?`, //收藏仪器
  delcollect: `${api}/web-api/web/gateway/deleteCollect?`, //取消收藏仪器
  delcollectsss: `${api}/web-api/web/gateway/deleteCollectList?`, //批量取消收藏仪器
  selectcollect: `${api}/web-api/web/gateway/selectCollectListWebPage`, //收藏仪器列表
  order: `${api}/web-api/web/gateway/orderCreate`, //创建仪器订单
  orderpage: `${api}/web-api/web/gateway/orderPage`, //仪器订单列表的状态
  orderpagestatus: `${api}/web-api/web/gateway/orderPageStatus`, //仪器订单列表
  orderstatus: `${api}/web-api/web/gateway/orderUpdateAuditStatus`, //仪器订单取消
  deleteorder: `${api}/web-api/web/gateway/deleteOrder?id=`, //仪器订单删除
  ordergetone: `${api}/web-api/web/gateway/orderGetOne?id=`, //仪器订单查看
  orderupdate: `${api}/web-api/web/gateway/orderUpdate`, //仪器订单修改
  guanzulie: `${api}/web-api/web/gateway/selectAttentionListWebPage`, //关注列表
  shuliang: `${api}/web-api/web/gateway/countByWebCollectPath`, //数量
  touxiang: `${api}/web-api/web/gateway/createAvatar?file=`, //头像
  // tok: `${api}/admin-api/system/oauth2/token`, //登录
  tok: `${api}/admin-api/system/auth/loginNoCode`, //登录
  captchaLogin: `${api}/admin-api/system/auth/login`, //带验证码登录
  captchaGet: `${api}/admin-api/system/captcha/get`, //获取滑块验证码
  captchaCheck: `${api}/admin-api/system/captcha/check`, //校验滑块验证码
  tryLogin: `${api}/admin-api/system/auth/social-login`,
  xx: `${api}/admin-api/system/oauth2/user/get/`, //登录信息
  time: `${api}/web-api/web/gateway/getOneSingleSureTimeList`, //预约时间列表
  // shuaxin: `${api}/admin-api/system/auth/refresh-token?refreshToken=`, //刷新令牌
  // shuaxin: `${api}/admin-api/system/oauth2/token`, //刷新令牌
  shuaxin: `${api}/admin-api/system/auth/refresh-token`, //刷新令牌
  cryptoSession: `${api}/admin-api/system/crypto/session`, //建立业务加密会话
  nriiauth: `${api}/admin-api/system/auth/social-nrii`, //
  pingjia: `${api}/web-api/web/gateway/orderUpdatecomment`, //用户评价
  zaiti: `${api}/web-api/web/gateway/getCenterListOfHome?cname=`, //资源载体
  guobie: `${api}/web-api/web/gateway/getNationListOfHome?nation=`, //产地国别
  danwei: `${api}/web-api/web/gateway/getdeptListOfWeb`, //单位列表
  jiudw: `${api}/web-api/web/gateway/updateUserAuthOfWebOldDept`, //关联旧单位
  xindw: `${api}/web-api/web/gateway/userCreateAuthOfWebNewDept`, //创建新单位
  shoushu: `${api}/web-api/web/gateway/countByInsAndSingleOfWeb`, //首页仪器数量
  linyu: `${api}/web-api/web/gateway/getIndustryListOfHome`, //产业领域
  bans: `${api}/web-api/web/gateway/newsLobbyPage`, //办事大厅
  sjdenglu: `${api}/admin-api/system/auth/sms-login`, //手机号登录
  yzmdenglu: `${api}/admin-api/system/auth/send-sms-code`, //发送验证码（登录）
  zhaohui: `${api}/admin-api/system/auth/send-sms-code`, //发送验证码（找回密码）
  zhyanz: `${api}/admin-api/system/auth/sms-password`, //找回密码验证
  yuyues: `${api}/web-api/web/gateway/getAppointmentClickOne?`, //点击预约仪器按钮
  zhiding: `${api}/web-api/web/gateway/newsUpPage`, //置顶新闻
  zucesj: `${api}/admin-api/system/auth/sendSmsCodeOfRegister`, //注册时手机验证码
  zxiang: `${api}/web-api/web/gateway/getOneRegulation`, //前端门户获得政策法规详情
};
